export const isSpecificSite = (site: "uk" | "ie", componentName: string) => {
	if (site === "ie" && process.env.GATSBY_IS_IE !== "true") {
		console.log("GATSBY_IS_IE", process.env.GATSBY_IS_IE);
		throw new Error(
			`Component: (${componentName}) should not be used on ${site}. Is IE: ${process.env.GATSBY_IS_IE}`,
		);
	}
	if (site === "uk" && process.env.GATSBY_IS_IE === "true") {
		throw new Error(
			`Component: (${componentName}) should not be used on ${site}. Is IE: ${process.env.GATSBY_IS_IE}`,
		);
	}
};
